import { getAppInfo, getAppID } from '@/utils/base'

export const loverflixTemplate = () => {
    return getAppID() === 'loverflix' || getAppID() === 'polarnovel'
}



export default {
    discover_tab: '発見',
    mine_tab: 'マイページ',
    bookshelf_tab: '本棚',
    ranking: 'ランキング',
    more: 'もっと',
    search_stories: 'ストーリーを検索',
    'you_might_like': 'おすすめ',
    'chapter': '章',
    'chapters': '章',
    'completed': '完了',
    'reviews': 'レビュー',
    'words': 'ワード',
    'summary': '概要',
    'read_now': '今すぐ読む',
    'add_to_library': 'ライブラリに追加',
    'select_payment_method': '支払い方法を選択',
    'most_popular': '最も人気',
    'weekly': '週間',
    'subscribe': '購読',
    'login': 'ログイン',
    'register': '登録',
    'logout': 'ログアウト',
    'sign_in_to_get_more': 'もっとを得るためにサインイン',
    'vip_status_inactive': 'VIPステータス: 無効',
    'vip_activated': 'VIP有効化済み',
    'active_wireless_reading_now': '今すぐワイヤレス読書を有効化',
    'question': 'カスタマーセンター',
    'terms_of_service': '利用規約',
    'privacy_policy': 'プライバシーポリシー',
    'search': '検索',
    'user': 'ユーザー',
    'password': 'パスワード',
    'by_continuing_you_agree_with_the': '続行することにより、あなたは以下に同意します: ',
    'and': 'および',
    'username_or_password_cannot_be_empty': 'ユーザー名またはパスワードは空にできません',
    'username_or_password_length_must_be_greater_than_8': 'ユーザー名またはパスワードの長さは8文字以上である必要があります',
    'register_success': '登録成功',
    'login_success': 'ログイン成功',
    'logout_success': 'ログアウト成功',
    'rules': '規則',
    'vip_member_benefits': 'VIP会員特典',
    'bookshelf_none': '本棚に本がありません。お気に入りの本を選びに書店へ行きましょう。',
    'go_to_the_bookstore': '書店へ行く',
    'search_none': `以前に消費したことがないようです`,
    'go_to_pay': '支払いページにリダイレクトされます。',
    'continue': '続ける',
    'PRIVACY': {
        content: `
                <h1>**プライバシーポリシー　Lambnovel プライバシーポリシー**</h1>
                <section>
                    <h2>Lambnovelプライバシーポリシーへようこそ。</h2>
                    <p>お客様がLambnovelのアプリケーションおよびサービスをご利用になることは、当社によるお客様の情報処理方法を信頼されていることを意味します。本プライバシーポリシーは、当社がどのような情報を収集するか、その理由、および情報がどのように使用されるかを理解していただくためのものです。当社の慣行をご理解いただくことは非常に重要ですので、ぜひ本ポリシーをお読みになる時間をお取りください。</p>
                </section>

                <section>
                    <h2>**当社のプライバシーポリシーについて**</h2>
                    <p>当社のプライバシーポリシーは、以下の側面を説明するものです：</p>
                    <ul>
                    <li>収集する情報、およびその収集理由。</li>
                    <li>情報の使用方法。</li>
                    </ul>
                </section>

                <section>
                    <h2>**収集する情報**</h2>
                    <p>すべてのユーザーに優れたサービスを提供するため、当社は合法的な目的で、推測可能な基本情報（使用言語など）からより複雑な情報（読書嗜好など）まで、お客様から情報を収集する場合があります。</p>

                    <h3>**情報の収集方法：**</h3>
                    <ul>
                    <li>
                        <p>**お客様から提供される情報：** 例えば、当社の書籍をダウンロードしたりソーシャルサービスを利用するには、Lambnovelアカウントの登録が必要です。登録時、電話番号や連携を許可されたソーシャルアカウント（Google+アカウント、Facebookアカウントなど）など、基本情報の提供をお願いします。これらの情報はお客様のアカウント下に保存され、Lambnovel内でこれらのソーシャルアカウントとの連携設定を提供しています。</p>
                    </li>
                    <li>
                        <p>
                        **サービスのご利用中に取得される情報：** 当社は、お客様が利用されるサービスとその利用方法に関する情報（オンライン書店の閲覧の有無、より多くの時間を費やす書籍のジャンルなど）を収集します。これには以下の情報が含まれます：</p>
                        <ul>
                        <li> **デバイス情報：** ハードウェアモデル、固有のデバイス識別子、モバイルネットワーク情報などのデバイス情報を収集する場合があります。</li>
                        <li>**位置情報：** Lambnovelをご利用の際、お客様の実際の位置に関する情報を収集・処理する場合があります。IPアドレスやGPSを含む様々な技術を使用して位置を特定します。</li>
                        <li>R**読書情報：** Lambnovelをご利用の際、メモ、閲覧履歴、書籍プレビュー履歴などの読書情報を収集します。</li>
                        </ul>
                    </li>
                    </ul>
                </section>

                <section>
                    <h2>**収集情報の使用方法**</h2>
                    <p>当社は、すべてのサービスから収集した情報を使用して、それらのサービスの提供、維持、保護、改善を行い、同時に新サービスの開発と情報セキュリティの維持に努めます。また、この種の情報を使用して、関連性の高い書籍ジャンルなど、お客様に合わせたカスタマイズコンテンツを提供します。</p>
                    <p>収集したデバイス情報は、初期Lambnovelアカウントを割り当てるために使用され、お客様ができるだけ早く当社の製品を使用し、オンライン書店を閲覧できるようにします。</p>
                    <p>位置情報は製品の社会的喜びを高めるために使用され、「近くの人」で志向を同じくする読者を見つけることができます。お客様のアカウント情報は当社のクラウドに保存されるため、いつでも1つのアカウントでサインインし、読書記録を同期できます。</p>
                </section>

                <section>
                    <h2>**共有される情報**</h2>
                    <p>当社は、書籍の共有や読書リストの共有など、興味深いソーシャル共有サービスを提供しています。当社はこれらの共有情報を記録しません。お客様はこれらのサービスを利用する際、ご自身の情報セキュリティに注意する必要があります。</p>
                </section>

                <section>
                    <h2>**個人情報の閲覧と更新**</h2>
                    <p>お客様が当社のサービスを利用される際は、常に個人情報への完全なアクセスを確保するよう努めます。これらの情報が誤っている場合、合法的な事業上の必要性または法的目的で情報を保持する必要がない限り、情報を迅速に更新または削除できる様々な方法を提供することに努めます。個人情報を更新する際、お客様のリクエストを処理する前に本人確認をお願いする場合があります。</p>
                    <p>終わりのない繰り返しのリクエスト、過度な技術的手段を必要とするリクエスト、他人のプライバシーを危険にさらすリクエスト、または非常に非現実的なリクエスト（バックアップテープに保存された情報など）については、お断りする場合があります。</p>
                    <p>当社が情報へのアクセスと変更を許可し、過度な入力を必要としない限り、無料で提供します。当社はサービスの保守を改善し、お客様の情報が偶発的または悪意のある損傷から保護されるよう努めます。したがって、お客様が当社のサービスから情報を削除しても、使用中のサーバーからこれらの情報の残余コピーを削除しない場合があり、バックアップシステムから対応する情報を削除しない場合もあります。</p>
                </section>

                <section>
                    <h2>**データの削除**</h2>
                    <p>お客様は、ops@novellettes.comまでご連絡いただくことで、いつでもデータの削除を要求できます。当社はそのようなリクエストをケースバイケースで評価します。詐欺の検出と防止、税務、法的報告、監査義務を含む法的義務の遵守など、正当な事業上の利益のために合理的に必要な限り、お客様のデータの一部を保持する場合があります。場合によっては、お客様のアカウントを閉鎖することでのみ、お客様のリクエストを満たすことができます。</p>
                    <p>お客様にはアカウントを削除する権利があり、アカウント削除時にプラットフォームの全部または一部へのアクセスまたは使用する権利を失うことを理解する必要があります。</p>
                </section>

                <section>
                    <h2>**製品の権限承認**</h2>
                    <p>いくつかの便利な機能を提供するため、Lambnovelをインストールする際、システムリソースの使用許可を求めます。これらの権限と用途は以下の通りです：</p>
                    <p>**メディアとファイル：** Lambnovelはダウンロードした書籍を保存するため、お客様のモバイルストレージの一部を占有する必要があります。</p>
                    <p>**カメラ：** Lambnovelは「スキャン」機能を提供し、お気に入りの書籍にLambnovelストアで電子版があるかどうかを素早く見つけ出すことができます。
*   **WLAN接続情報：** WLANを使用する際、比較的大きなサイズのプラグインのダウンロードをお勧めする場合があります。</p>
                    <p>**デバイスID：** デバイスIDは重要なパラメータであり、これに基づいてLambnovelゲストアカウントを初期化できます。</p>
                </section>

                <section>
                    <h2**プライバシーポリシーの適用**</h2>
                    <p>本プライバシーポリシーは lambnovel.com に適用されます。当社のサービスを広告し、Cookie、ピクセルタグ、その他の技術を使用して関連広告を配信・提供する可能性のある他の企業および組織に関しては、当社のプライバシーポリシーはそれらの情報処理の慣行を網羅するものではありません。</p>
                </section>

                <h3>本契約は、中華人民共和国香港特別行政区の法律に準拠して解釈されるものとします。</h3>
        `
    },
    SERVICE: {
        content: `
             <h1>利用規約</h1>
    <p class="intro">Lambnovelへようこそ！</p>
    <p class="intro">本Lambnovelサービス契約（以下「本契約」といいます）は、Kynix Group Limited（所在地：RM 10D R1, 10/F KIN GA IND BLDG 9 SAN ON ST TUEN MUN HONG KONG）（以下「提供者」といいます）と、Lambnovelのユーザー（以下「ユーザー」といいます）との間で、「Lambnovel」アプリケーション（以下「本アプリ」といいます）のインストール、使用および関連事項に関して締結されるものです。「同意する」をクリック、またはその他の方法で本契約に同意することにより、ユーザーはLambnovelとの契約が成立し、以下の全ての条項を受け入れたことを承認するものとします。</p>

    <h2>第1条 ユーザーサービス</h2>
    <p>ユーザーは、(i) 本アプリをインストール、複製、ダウンロード、訪問、その他あらゆる方法で使用する前に本契約を精読し、これに同意すること、(ii) 提供者が指定するウェブサイトまたはメディアから本アプリをダウンロードすることを必須とします。ユーザーが本契約に違反したことにより生じたいかなる可能性のあるリスクおよび/または損害についても、提供者は一切の義務または責任を負いません。</p>

    <h2>第2条 知的財産権</h2>
    <ol>
        <li>2.1 提供者は、本アプリの著作権者です。本アプリのすべての知的財産権、および本アプリに関連する情報コンテンツ（これらに限定されないものとして、文字表現およびその組み合わせ、アイコン、図形装飾、画像、図表、色彩、インターフェースデザイン、レイアウトフレームワーク、関連データ、追加プログラム、印刷物または電子文書など）は、著作権法および国際著作権条約ならびにその他の知的財産権に関する法律・規制によって保護されています。ユーザーは、提供者による事前の書面による承認なしに、本アプリのリバースエンジニアリング、逆コンパイル、または分解を行ってはなりません。</li>
        <li>2.2 ユーザーは、提供者により提供されるネットワークサービスの一切の文章、画像、図形資料が、著作権、商標権および/またはその他の財産所有権の法律によって保護されていることを承認します。提供者による事前の書面による承認なしに、上記情報を (i) いかなる媒体においても直接的または間接的に公表または放送すること、(ii) 公表または放送する目的で書き換えまたは再公表すること、または (iii) その他のいかなる商業的目的にも使用することはできません。情報の全部または一部は、私的かつ非営利目的でのみ、ユーザーの端末に保存することができます。提供者は、(i) 情報自体の遅延、不正確、誤り、省略、または (ii) 情報またはその一部の伝送または提出中に生じた遅延、不正確、誤り、省略による、いかなるユーザーまたは第三者に対するいかなる損害および/または損失についても、一切の義務または責任を負いません。</li>
    </ol>

    <h2>第3条 支払い</h2>
    <ol>
        <li>3.1 本アプリのダウンロードおよび使用中に、モバイル通信事業者によりインターネット接続料が発生・請求される場合があります。詳細は、お客様の地域のモバイル通信事業者にお問い合わせください。</li>
        <li>3.2 本アプリは、著作権者から許諾された書籍を提供します。ユーザーは、一部の書籍またはコンテンツを読む際に料金が発生する場合があります。本アプリは、課金前にユーザーに具体的なプロンプトを表示します。ユーザーが「キャンセル」または「戻る」を押してキャンセルした場合、提供者は一切の料金を請求しません。</li>
        <li>3.3 本アプリは、Googleウォレットなどを含む（ただしこれらに限定されない）支払い方法を受け付けます。ユーザーが本契約に同意することにより、本アプリの支払い方法を受け入れたものとみなされます。</li>
    </ol>

    <h2>第4条 ユーザーの義務</h2>
    <ol>
        <li>4.1 ユーザーは、本アプリを (i) 合法的かつ誠実に、(ii) いかなる第三者の正当な権利および利益も侵害することなく、使用することを表明し保証します。</li>
        <li>4.2 ユーザーは、本アプリに保存されている機能やデータを悪意を持って削除、変更、追加したり、提供者が本アプリの著作権を保護するために設けた技術的措置を故意に回避または破壊したりしないことを表明し保証します。ユーザーは、この条項への違反により引き起こされるすべてのリスクと責任を負うものとします。ユーザーが本アプリをいかなる違法行為に関与させ、または本契約の目的に違反した場合、提供者はユーザーへのサービス提供を直ちに停止する権利を有し、司法ルートを通じてユーザーの責任を追及・確定する権利を留保します。</li>
        <li>4.3 ユーザーは、(i) 商業目的で提供者の製品およびサービスを模倣すること、(ii) 提供者のデザイン哲学、インターフェース、機能および図表を複製または模倣すること、または (iii) 提供者の事前の書面による承認なしに本アプリを改変または他の派生产品を作成しないことを表明し保証します。</li>
        <li>4.4 ユーザーは、本アプリまたはそのサービスを使用して、適用される法律に違反するコンテンツを作成、アップロード、複製、送信、共有してはなりません。</li>
        <li>4.5 ユーザーは、本契約違反により提供者および/または他の者に生じた損失に対する賠償の責任をすべて負うものとします。提供者がそのような責任を負った場合、ユーザーは提供者の関連費用および損失（合理的な弁護士費用を含む）を賠償しなければなりません。</li>
        <li>4.6 ユーザーは、上記の表明および保証、または提供者の規則および/または通知のいずれかに違反した場合、一切の返金または事前通知なしに本アプリの使用が直ちに終了する可能性があることを承認します。</li>
        <li>4.7 ユーザーは、本アプリを使用しながら、提供者が提供するすべての情報サービスを受け入れることに同意します。</li>
    </ol>

    <h2>第5条 権利と義務</h2>
    <ol>
        <li>5.1 提供者は、運営およびネットワーク環境のニーズに基づき、いつでも本アプリを修正および更新する権利を有します。</li>
        <li>5.2 ユーザーが本アプリの使用中に本契約に違反し、提供者に損害を与えた場合、提供者は、ライセンスおよびサービスの停止、使用制限、法的責任の調査・追及などを含む（これらに限定されない）措置を取る権利を有します。</li>
        <li>5.3 提供者は、単独の裁量により、ユーザーに対する一切の責任および/または通知なしに、いつでも本アプリの提供を中止する場合があります。</li>
    </ol>

    <h2>第6条 免責事項および責任制限</h2>
    <p>ユーザーは、提供者が以下の状況について一切の責任を負わないことを承認します（これらに限定されません）：</p>
    <ol>
        <li>6.1 ハリケーン、地震、津波、洪水、停電、戦争、テロ攻撃など（「不可抗力」）によるシステム問題。</li>
        <li>6.2 ハッカー攻撃、通信部門の技術調整または障害、ウェブサイト更新、銀行の問題などによるサービス問題。</li>
        <li>6.3 提供者は、(i) 本アプリに技術的なバグがないこと、(ii) 提供者が本アプリのすべてのバグを修正すること、(iii) 本アプリがユーザーのすべてのニーズを満たすことを保証しません。</li>
        <li>6.4 本契約または本アプリに対する不満の唯一の解決策は、本アプリの使用を停止することです。</li>
        <li>6.5 ユーザーは、本契約はこれに準拠し、本契約から生じるまたは関連するいかなる紛争も、提供者とユーザーが誠実に協議するものとすることに同意します。ただし、紛争が解決できない場合、双方は、提供者の所在地を管轄する地方裁判所に仲裁を付託することに同意します。</li>
        <li>6.6 本契約のいずれかの条項が、いかなる理由であれ、完全にまたは部分的に無効もしくは執行不能、またはいかなる適用される法律にも違反する場合、当該条項は削除されたものとみなされます。本契約の他の条項は有効であり、拘束力を有します。</li>
    </ol>

    <h2>第7条 自動更新サービス規則</h2>
    <p>Lambnovel会員自動更新サービス（以下「自動更新サービス」といいます）を購読、開設、および使用することにより、ユーザーはこれらの規則に同意するものとします。</p>
    <p>ユーザーは以下を理解し、同意します：</p>
    <ol>
        <li>7.1 ユーザーが本自動更新サービスを開設し、購読期間中に本自動更新サービスを明示的にキャンセルしない場合、関連事業者は、各購読期間の終了日の1日前に、ユーザー自身のチャージ済みアカウント、紐付けされたサードパーティ決済アカウント、銀行カード、通信アカウントなど（以下「アカウント」といいます）から残高を自動的に控除します。次回購読期間のサービス料金はユーザーのアカウント残高から自動的に控除され、対応する購読期間の有効期間が延長されます。ユーザーは上記アカウントおよび引き落とし可能残高の状態に注意を払うべきであり、アカウントの問題または残高不足による更新失敗のリスクおよび/または損失はユーザーが負担します。</li>
        <li>7.2 購読期間：1週間、1年など（購読ページの説明に従います）。会員は各自で選択できます。</li>
        <li>7.3 Lambnovelは有料サービスの新規購読者に無料トライアルを提供する場合があります。無料トライアルを含む有料サービス購読を購入した場合、無料トライアル期間中は有料サービスを無料でご利用いただけます。適用される無料トライアル期間の終了時に、購読料が課金され、ユーザーが購読をキャンセルするまで課金が継続します。いかなる料金も発生させないためには、無料トライアル期間終了前にキャンセルする必要があります。</li>
        <li>7.4 ユーザーは、Lambnovelがサービスの価格を調整する権利を有することを承認し、同意します。ユーザーが自動更新サービスを有効化した後、Lambnovelがサービスの価格調整を意図する場合、Lambnovelは適切な手段（サイト内告知、SMSなどを含むがこれらに限定されない）で事前に通知します。ユーザーがサービスの価格調整に同意しない場合、これらの規則に従って本自動更新サービスをキャンセルすることができます。ユーザーが本自動更新サービスをキャンセルしない場合、関連事業者がその後控除するサービス料金は、調整後のサービス料金に基づきます。ユーザーが購読期間終了の24時間以内にキャンセルした場合、関連事業者は調整後のサービス料金に基づく次回購読期間のサービス料金の控除を停止する場合があります。本自動更新サービスのキャンセル後、ユーザーが再度自動更新サービスを開設した場合、関連事業者が自動的に控除するサービス料金は、当時のページに表示されるサービス料金に基づくものとします。</li>
        <li>7.5 自動更新ユーザーの解約方法は以下の通りです。
            <p>自動更新の有料サービス購読を購入した場合、現在の請求期間終了前であればいつでも購読をキャンセルでき、キャンセルは次の請求期間から有効になります。ユーザーは、キャンセル日から次の請求期間の開始日まで有料サービスへのアクセス権を保持します。</p>
            <p>Apple IAP（アプリ内課金）でのお支払い：iOSデバイスの「設定」を開く → 「iTunes Store と App Store」へ進む → 「Apple ID」をクリック、「Apple IDを表示」を選択、「アカウント設定」ページに入る、「購読」をクリックし、Lambnovel会員を選択して購読をキャンセルします。購読期間終了の1日前までに自動更新機能をキャンセルしない場合、購読は自動的に更新・引き落としされます。</p>
            <p>Google Play ストア：Google Playにアクセス → 「設定」をクリック → 「購読」をクリックし、Lambnovel会員を選択して購読をキャンセルします。購読期間終了の1日前までに自動更新機能をキャンセルしない場合、購読は自動的に更新・引き落としされます。</p>
        </li>
        <li>7.6 Lambnovelはその運営戦略に従い、ユーザーへの自動更新サービスの提供を停止する場合もあり、その場合、ユーザーのLambnovel会員資格は現在のサービス期間の満了日をもって終了します。</li>
    </ol>

    <h2>第8条 コンテンツ関連事項</h2>
    <p>Lambnovelが安全で文明的プラットフォームであり続けることを確保するため、当社はユーザーに有害または不適切なコンテンツを定義し、そのようなコンテンツが当社プラットフォームに出現することを禁止する一連の基準を策定しました。</p>
    <ul>
        <li><strong>CSAM/CSEM（児童性的虐待素材）</strong>：書籍が児童虐待コンテンツを含む場合、当社は直ちにLambnovelからそれを削除します。これには全ての児童性的虐待コンテンツが含まれます。</li>
        <li><strong>強姦</strong>：いかなる書籍も、強制的な性的コンテンツまたは強制的ないじめを含むことを許可しません。</li>
        <li><strong>近親相姦</strong>：いかなる書籍も、人間の倫理と社会規範を損なう内容、近親者間の不適切な性的関係を含むことを許可しません。</li>
        <li><strong>獣姦</strong>：いかなる書籍も、人間と野生動物との間の性行為を含むことを許可しません。</li>
    </ul>
    <p>このような問題に対して、当社は絶え間ないコンテンツチェックを実施します。発見次第、直ちにコンテンツを削除し、当該書籍の著者がプラットフォーム上でそのコンテンツを公開することを永久に禁止します。当社が提供する書籍についてご質問がある場合は、<a href="mailto:ops@novellettes.com" class="contact">ops@novellettes.com</a>までご連絡ください。</p>

    <p class="final-note">本契約は、中華人民共和国香港特別行政区の法律に準拠して解釈されるものとします。</p>
        `
    },
    ABOUT: {
        content: `
            <section>
                <p>定期購読サービスを解約される場合は、以下の方法でお手続きください：</p>
                <p>
                    ops@novellettes.com にメールをお送りいただき、お支払いアカウントのメールアドレスとサービス開始日をご連絡ください。
                </p>
                <p>
                    ご不明な点がございましたら、メールでお問い合わせください。24時間以内にご返信いたします。
                </p>
               
            </section>
        `
    },
    AGREEMENT: {
        content: `
            <section>
                <h1>Clockwise Subscription Agreement</h1>
                <h3>Last Updated: [01.20.2025]</h3>
                <h3>1. Subscription Services</h3>
                <p>
                This Subscription Agreement ("Agreement") governs your access to [Novellettes] ("Service") provided by [ CLOCKWISE INTERNATIONAL (HONG KONG) LIMITED] ("Company," "we," or "us"). By subscribing, you ("User," "you") agree to be bound by these terms.
                </p>
                <h3>
                2. Subscription Plans & Auto-Renewal
                </h3>
                <p>
                Subscription Tiers:
                </p>
                <p>
                All subscription levels are subject to the actual payment page.
                </p>
                <p>
                First week discount, subsequent deductions will be based on the original price.
                </p>
                <p>
                Auto-Renewal:
                </p>
                <p>
                Subscription are automatically charged each billing period, whether weekly or another period, and you may be charged no more than 24 hours before the beginning of each billing period until you cancel your subscription.
                </p>
                <p>You authorize recurring charges to your designated payment method through Payermax until cancellation.</p>
                <h3>3. Payment Terms & No Free Trial</h3>
                <p>No Free Trial: The Service begins immediately upon payment confirmation. No free trial period is offered.</p>
                <p>Payment Processing:</p>
                <p>All fees are processed securely via Payermax. You agree to maintain valid and updated payment information.</p>
                <p>Prices are subject to change with 30 days’ notice. Continued use after notice constitutes acceptance.</p>
                <p>Non-Refundable Payments: All fees are final and non-refundable unless otherwise required by applicable law.</p>
                <h3>4. Cancellation & Refund Requests</h3>
                <p>Cancellation: To prevent auto-renewal, you must cancel your subscription through your account settings or email service@novellettes.com at least [1 days] before the next billing cycle.</p>
                <p>Refunds:</p>
                <p>Refund requests must be submitted via email to service@novellettes.com.</p>
                <p>Refunds are granted only if mandated by law (e.g., consumer protection regulations).</p>
                <h3>5. User Responsibilities</h3>
                <p>Ensure all account and billing information is accurate and current.</p>
                <p>Do not share accounts, reverse-engineer, or misuse the Service.</p>
                <h3>6. Termination</h3>
                <p>We reserve the right to suspend or terminate your subscription without prior notice for violations of this Agreement, fraudulent activity, or failure to pay fees.</p>
                <h3>7. Disclaimer & Liability</h3>
                <p>"As Is" Service: The Service is provided without warranties of any kind, express or implied.</p>
                <p>Limitation of Liability: We are not liable for indirect, incidental, or consequential damages arising from your use of the Service.</p>
                <h3>8. Governing Law & Amendments</h3>
                <p>Governing Law: This Agreement is governed by the laws of [HongKong].</p>
                <p>Updates: We may modify these terms with 30 days’ advance notice (via email or in-app notification). Continued use constitutes acceptance.</p>
                <h3>Acknowledgment</h3>
                <p>By subscribing, you confirm that you have read, understood, and agreed to this Agreement.</p>
            </section>
        
        `
    },
    'VIP_INTEREST': {
        1: `1万冊以上の厳選書籍が無制限で無料`,
        2: '毎週200冊以上の新刊を配信',
        3: '広告なしの快適な読書環境'
    },
    'VIP_RULES': {
        content: `
            <p> 価格： 初週は割引価格、その後は定価に基づいて課金されます。</p>
            <p>• 読書ルール： 未購読でも無料チャプターはお読みいただけます。</p>
            <p>• 支払い： 購入金額はApp Storeアカウントに請求されます。</p>
            <p>• 更新： ご契約は自動的に更新されます。</p>
            <p>• 各課金期間（週単位またはその他の期間）ごとに自動的に課金が行われ、ご契約を解約されるまで、各課金期間開始前24時間以内に請求される場合があります。</p>
            <p>• 解約： 更新日の24時間以上前であれば、いつでも解約可能です。</p>
            <p>• 定期購読の管理： アカウント設定から定期購読の確認、変更、解約ができます。</p>
        
        `
    }
}